export default "__VITE_ASSET__ByzVztkd__"